var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 38,
    viewBox: "0 0 34 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41797 35.6667V33.5833C2.41797 31.6682 2.79518 29.7719 3.52806 28.0025C4.26094 26.2332 5.33514 24.6255 6.68933 23.2714C8.04352 21.9172 9.65117 20.843 11.4205 20.1101C13.1898 19.3772 15.0862 19 17.0013 19C18.9164 19 20.8128 19.3772 22.5821 20.1101C24.3514 20.843 25.9591 21.9172 27.3133 23.2714C28.6675 24.6255 29.7417 26.2332 30.4745 28.0025C31.2074 29.7719 31.5846 31.6682 31.5846 33.5833V35.6667",
    stroke: "#07D3C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0013 18.9987C19.2114 18.9987 21.3311 18.1207 22.8939 16.5579C24.4567 14.9951 25.3346 12.8755 25.3346 10.6654C25.3346 8.45523 24.4567 6.33561 22.8939 4.77281C21.3311 3.21 19.2114 2.33203 17.0013 2.33203C14.7912 2.33203 12.6715 3.21 11.1087 4.77281C9.54594 6.33561 8.66797 8.45523 8.66797 10.6654C8.66797 12.8755 9.54594 14.9951 11.1087 16.5579C12.6715 18.1207 14.7912 18.9987 17.0013 18.9987V18.9987Z",
    stroke: "#07D3C4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuman);
export default __webpack_public_path__ + "static/media/Human.09e7c84a56651e37e80543f8e73c4fcd.svg";
export { ForwardRef as ReactComponent };